/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiUTMEntityLevel;
(function (ApiUTMEntityLevel) {
    ApiUTMEntityLevel["UNSPECIFIED"] = "UTM_ENTITY_LEVEL_UNSPECIFIED";
    ApiUTMEntityLevel["CAMPAIGN"] = "UTM_ENTITY_LEVEL_CAMPAIGN";
    ApiUTMEntityLevel["AD_GROUP"] = "UTM_ENTITY_LEVEL_AD_GROUP";
    ApiUTMEntityLevel["AD"] = "UTM_ENTITY_LEVEL_AD";
})(ApiUTMEntityLevel || (ApiUTMEntityLevel = {}));
export function ApiUTMEntityLevelFromJSON(json) {
    return ApiUTMEntityLevelFromJSONTyped(json, false);
}
export function ApiUTMEntityLevelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiUTMEntityLevelToJSON(value) {
    return value;
}
